export const islamicComponentIds = [
    "prayer",
    "quran",
    "quranAudio",
    "quranWordByWord",
    "tafsir",
    "dailyAyah",
    "hadith",
    "dailyHadith",
    "duas",
    "dailyDua",
    "namesOfAllah",
    "hijriCalendar",
];
export const islamicHomeSectionIds = [
    "prayer",
    "dailyIslamicContent",
    "upNext",
    "forYou",
    "latest",
    "communityImpact",
    "acrossCommunities",
];
export const hijriDateDisplayPreferences = [
    "gregorianOnly",
    "hijriSecondary",
    "hijriPrimary",
];
export const dailyIslamicContentModes = ["automatic", "curated", "off"];
const communityCoreEntitlement = ["community.core"];
const definitionSeeds = [
    {
        category: "prayer",
        componentId: "prayer",
        dependencyComponentIds: [],
        description: "Home prayer schedule, iqamah times, notifications, and Qibla support.",
        descriptionAr: "أوقات الصلاة والإقامة والتنبيهات ودعم القبلة في الصفحة الرئيسية.",
        displayName: "Prayer Times",
        displayNameAr: "أوقات الصلاة",
        homeEligible: true,
        platformEnabled: true,
        sortOrder: 10,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "quran",
        componentId: "quran",
        dependencyComponentIds: [],
        description: "Foundation toggle for future Quran reading experiences.",
        descriptionAr: "تحكم أساسي لتجارب قراءة القرآن القادمة.",
        displayName: "Quran",
        displayNameAr: "القرآن",
        homeEligible: false,
        platformEnabled: true,
        sortOrder: 20,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "quran",
        componentId: "quranAudio",
        dependencyComponentIds: ["quran"],
        description: "Foundation toggle for future Quran audio playback.",
        descriptionAr: "تحكم أساسي لتشغيل تلاوات القرآن لاحقاً.",
        displayName: "Quran Audio",
        displayNameAr: "تلاوة القرآن",
        homeEligible: false,
        platformEnabled: true,
        sortOrder: 30,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "quran",
        componentId: "quranWordByWord",
        dependencyComponentIds: ["quran"],
        description: "Foundation toggle for future word-by-word Quran assistance.",
        descriptionAr: "تحكم أساسي لدعم القرآن كلمة بكلمة لاحقاً.",
        displayName: "Word by Word",
        displayNameAr: "كلمة بكلمة",
        homeEligible: false,
        platformEnabled: true,
        sortOrder: 40,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "quran",
        componentId: "tafsir",
        dependencyComponentIds: ["quran"],
        description: "Foundation toggle for future tafsir access.",
        descriptionAr: "تحكم أساسي للوصول إلى التفسير لاحقاً.",
        displayName: "Tafsir",
        displayNameAr: "التفسير",
        homeEligible: false,
        platformEnabled: true,
        sortOrder: 50,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "daily",
        componentId: "dailyAyah",
        dependencyComponentIds: ["quran"],
        description: "Daily Ayah availability inside the unified Daily Home component.",
        descriptionAr: "إتاحة آية اليوم داخل مكوّن اليومي الموحد في الصفحة الرئيسية.",
        displayName: "Daily Ayah",
        displayNameAr: "آية اليوم",
        homeEligible: true,
        platformEnabled: true,
        sortOrder: 60,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "library",
        componentId: "hadith",
        dependencyComponentIds: [],
        description: "Deprecated standalone Hadith library toggle retained for compatibility.",
        descriptionAr: "تحكم مكتبة الحديث المستقلة متوقف ومحتفظ به للتوافق.",
        displayName: "Hadith Library (deprecated)",
        displayNameAr: "الحديث",
        homeEligible: false,
        platformEnabled: false,
        sortOrder: 70,
        status: "disabled",
        userConfigurable: false,
    },
    {
        category: "daily",
        componentId: "dailyHadith",
        dependencyComponentIds: [],
        description: "Daily Hadith availability inside the unified Daily Home component.",
        descriptionAr: "إتاحة حديث اليوم داخل مكوّن اليومي الموحد في الصفحة الرئيسية.",
        displayName: "Daily Hadith",
        displayNameAr: "حديث اليوم",
        homeEligible: true,
        platformEnabled: true,
        sortOrder: 80,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "library",
        componentId: "duas",
        dependencyComponentIds: [],
        description: "Deprecated standalone Duas library toggle retained for compatibility.",
        descriptionAr: "تحكم مكتبة الأدعية المستقلة متوقف ومحتفظ به للتوافق.",
        displayName: "Duas Library (deprecated)",
        displayNameAr: "الأدعية",
        homeEligible: false,
        platformEnabled: false,
        sortOrder: 90,
        status: "disabled",
        userConfigurable: false,
    },
    {
        category: "daily",
        componentId: "dailyDua",
        dependencyComponentIds: [],
        description: "Daily Dua availability inside the unified Daily Home component.",
        descriptionAr: "إتاحة دعاء اليوم داخل مكوّن اليومي الموحد في الصفحة الرئيسية.",
        displayName: "Daily Dua",
        displayNameAr: "دعاء اليوم",
        homeEligible: true,
        platformEnabled: true,
        sortOrder: 100,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "library",
        componentId: "namesOfAllah",
        dependencyComponentIds: [],
        description: "99 Names of Allah reference destination in Explore -> Islamic.",
        descriptionAr: "وجهة أسماء الله الحسنى داخل الاستكشاف الإسلامي.",
        displayName: "99 Names of Allah",
        displayNameAr: "أسماء الله الحسنى",
        homeEligible: false,
        platformEnabled: true,
        sortOrder: 110,
        status: "active",
        userConfigurable: true,
    },
    {
        category: "calendar",
        componentId: "hijriCalendar",
        dependencyComponentIds: [],
        description: "Calculated Hijri date display and Hijri month calendar.",
        descriptionAr: "عرض التاريخ الهجري المحسوب والتقويم الشهري الهجري.",
        displayName: "Hijri Calendar",
        displayNameAr: "التقويم الهجري",
        homeEligible: false,
        platformEnabled: true,
        sortOrder: 120,
        status: "active",
        userConfigurable: true,
    },
];
export const approvedIslamicComponentDefinitions = definitionSeeds.map((definition) => ({
    ...definition,
    requiredEntitlementIds: definition.requiredEntitlementIds ?? communityCoreEntitlement,
    schemaVersion: 1,
    source: "p1_islamic_components",
    updatedAt: "development-seed",
}));
export const defaultIslamicHomeSectionOrder = [
    "prayer",
    "dailyIslamicContent",
    "upNext",
    "forYou",
    "latest",
    "communityImpact",
    "acrossCommunities",
];
export function isIslamicComponentId(value) {
    return islamicComponentIds.includes(value);
}
export function isIslamicHomeSectionId(value) {
    return islamicHomeSectionIds.includes(value);
}
export function isHijriDateDisplayPreference(value) {
    return hijriDateDisplayPreferences.includes(value);
}
export function isDailyIslamicContentMode(value) {
    return dailyIslamicContentModes.includes(value);
}
export function islamicComponentDefinitionMap(definitions = approvedIslamicComponentDefinitions) {
    return Object.fromEntries(islamicComponentIds.map((componentId) => [
        componentId,
        definitions.find((definition) => definition.componentId === componentId) ??
            approvedIslamicComponentDefinitions.find((definition) => definition.componentId === componentId),
    ]));
}
export function buildDefaultOrganizationIslamicComponentConfig(input) {
    const disabled = new Set(input.disabledComponentIds ?? []);
    const components = Object.fromEntries(approvedIslamicComponentDefinitions.map((definition) => [
        definition.componentId,
        {
            enabled: definition.platformEnabled &&
                definition.status === "active" &&
                !disabled.has(definition.componentId),
            homeEnabled: definition.homeEligible &&
                definition.platformEnabled &&
                definition.status === "active" &&
                !disabled.has(definition.componentId),
        },
    ]));
    return {
        components,
        configDocument: "islamicComponents",
        dailyAyahReference: null,
        dailyContentDate: null,
        dailyContentMode: "automatic",
        dailyDuaReference: null,
        dailyHadithReference: null,
        hijriDateDisplay: "hijriSecondary",
        organizationId: input.organizationId,
        schemaVersion: 1,
        source: "p1_islamic_components",
        updatedAt: input.timestamp,
        updatedBy: input.updatedBy,
    };
}
export function normalizeOrganizationIslamicComponentConfig(organizationId, value) {
    const fallback = buildDefaultOrganizationIslamicComponentConfig({
        organizationId,
        timestamp: "unknown",
        updatedBy: "system:default",
    });
    const componentsValue = isRecord(value?.components) ? value?.components : undefined;
    const components = Object.fromEntries(islamicComponentIds.map((componentId) => {
        const componentValue = isRecord(componentsValue?.[componentId])
            ? componentsValue?.[componentId]
            : undefined;
        return [
            componentId,
            {
                enabled: typeof componentValue?.enabled === "boolean"
                    ? componentValue.enabled
                    : fallback.components[componentId].enabled,
                homeEnabled: typeof componentValue?.homeEnabled === "boolean"
                    ? componentValue.homeEnabled
                    : fallback.components[componentId].homeEnabled,
            },
        ];
    }));
    const hijriDateDisplay = typeof value?.hijriDateDisplay === "string" &&
        isHijriDateDisplayPreference(value.hijriDateDisplay)
        ? value.hijriDateDisplay
        : fallback.hijriDateDisplay;
    const dailyContentMode = typeof value?.dailyContentMode === "string" && isDailyIslamicContentMode(value.dailyContentMode)
        ? value.dailyContentMode
        : fallback.dailyContentMode;
    return {
        ...fallback,
        components,
        dailyAyahReference: optionalReferenceValue(value?.dailyAyahReference),
        dailyContentDate: optionalDateIdValue(value?.dailyContentDate),
        dailyContentMode,
        dailyDuaReference: optionalReferenceValue(value?.dailyDuaReference),
        dailyHadithReference: optionalReferenceValue(value?.dailyHadithReference),
        hijriDateDisplay,
        updatedAt: value?.updatedAt ?? fallback.updatedAt,
        updatedBy: typeof value?.updatedBy === "string" ? value.updatedBy : fallback.updatedBy,
    };
}
export function parseOrganizationIslamicComponentsSettingsRequestBody(value) {
    const organizationId = textValue(value.organizationId, 140);
    const enabledComponentIds = componentIdListValue(value.enabledComponentIds);
    const homeEnabledComponentIds = componentIdListValue(value.homeEnabledComponentIds);
    const hijriDateDisplay = textValue(value.hijriDateDisplay, 40);
    const dailyContentMode = textValue(value.dailyContentMode, 40);
    const dailyContentDate = optionalDateIdValue(value.dailyContentDate);
    const dailyAyahReference = optionalReferenceValue(value.dailyAyahReference);
    const dailyHadithReference = optionalReferenceValue(value.dailyHadithReference);
    const dailyDuaReference = optionalReferenceValue(value.dailyDuaReference);
    if (!organizationId ||
        !enabledComponentIds ||
        !homeEnabledComponentIds ||
        !hijriDateDisplay ||
        !dailyContentMode ||
        !isHijriDateDisplayPreference(hijriDateDisplay) ||
        !isDailyIslamicContentMode(dailyContentMode) ||
        optionalValueWasMalformed(value.dailyContentDate, dailyContentDate) ||
        optionalValueWasMalformed(value.dailyAyahReference, dailyAyahReference) ||
        optionalValueWasMalformed(value.dailyHadithReference, dailyHadithReference) ||
        optionalValueWasMalformed(value.dailyDuaReference, dailyDuaReference)) {
        return null;
    }
    const definitionMap = islamicComponentDefinitionMap();
    for (const componentId of homeEnabledComponentIds) {
        if (!definitionMap[componentId].homeEligible) {
            return null;
        }
    }
    return {
        dailyAyahReference,
        dailyContentDate,
        dailyContentMode,
        dailyDuaReference,
        dailyHadithReference,
        enabledComponentIds,
        hijriDateDisplay,
        homeEnabledComponentIds,
        organizationId,
    };
}
export function buildOrganizationIslamicComponentSettingsUpdate(request, timestamp, actorUid) {
    const enabled = new Set(request.enabledComponentIds);
    const homeEnabled = new Set(request.homeEnabledComponentIds);
    const definitionMap = islamicComponentDefinitionMap();
    const components = Object.fromEntries(islamicComponentIds.map((componentId) => [
        componentId,
        {
            enabled: enabled.has(componentId),
            homeEnabled: definitionMap[componentId].homeEligible &&
                enabled.has(componentId) &&
                homeEnabled.has(componentId),
        },
    ]));
    return {
        components,
        configDocument: "islamicComponents",
        dailyAyahReference: request.dailyAyahReference ?? null,
        dailyContentDate: request.dailyContentDate ?? null,
        dailyContentMode: request.dailyContentMode,
        dailyDuaReference: request.dailyDuaReference ?? null,
        dailyHadithReference: request.dailyHadithReference ?? null,
        hijriDateDisplay: request.hijriDateDisplay,
        organizationId: request.organizationId,
        schemaVersion: 1,
        source: "p1_islamic_components",
        updatedAt: timestamp,
        updatedBy: actorUid,
    };
}
export function validateOrganizationIslamicComponentSettingsAvailability(input) {
    const definitionMap = islamicComponentDefinitionMap(input.definitions);
    const enabled = new Set(input.request.enabledComponentIds);
    const enabledEntitlements = new Set(input.enabledEntitlementIds ?? []);
    for (const componentId of input.request.enabledComponentIds) {
        const definition = definitionMap[componentId];
        if (definition.status !== "active" || !definition.platformEnabled) {
            return {
                componentId,
                ok: false,
                reason: "platform_component_disabled",
            };
        }
        const entitlementSatisfied = definition.requiredEntitlementIds.every((entitlementId) => enabledEntitlements.has(entitlementId));
        if (!entitlementSatisfied) {
            return {
                componentId,
                ok: false,
                reason: "entitlement_missing",
            };
        }
        const dependencySatisfied = definition.dependencyComponentIds.every((dependencyId) => enabled.has(dependencyId));
        if (!dependencySatisfied) {
            return {
                componentId,
                ok: false,
                reason: "component_dependency_required",
            };
        }
    }
    return { ok: true };
}
export function resolveEffectiveOrganizationIslamicComponents(input) {
    const definitionMap = islamicComponentDefinitionMap(input.definitions);
    const enabledEntitlements = new Set(input.enabledEntitlementIds ?? []);
    const organizationEnabled = new Map(islamicComponentIds.map((componentId) => [
        componentId,
        input.config.components[componentId].enabled === true,
    ]));
    const components = Object.fromEntries(islamicComponentIds.map((componentId) => {
        const definition = definitionMap[componentId];
        const entitlementSatisfied = definition.requiredEntitlementIds.every((entitlementId) => enabledEntitlements.has(entitlementId));
        const dependencySatisfied = definition.dependencyComponentIds.every((dependencyId) => {
            const dependency = definitionMap[dependencyId];
            return (dependency.status === "active" &&
                dependency.platformEnabled &&
                organizationEnabled.get(dependencyId) === true);
        });
        const unavailableReasons = [
            definition.status !== "active" || !definition.platformEnabled ? "platform_disabled" : null,
            !input.config.components[componentId].enabled ? "organization_disabled" : null,
            entitlementSatisfied ? null : "entitlement_missing",
            dependencySatisfied ? null : "dependency_disabled",
        ].filter((reason) => reason !== null);
        const effectiveEnabled = unavailableReasons.length === 0;
        return [
            componentId,
            {
                category: definition.category,
                componentId,
                dependencyComponentIds: definition.dependencyComponentIds,
                dependencySatisfied,
                description: definition.description,
                descriptionAr: definition.descriptionAr,
                displayName: definition.displayName,
                displayNameAr: definition.displayNameAr,
                effectiveEnabled,
                entitlementSatisfied,
                homeEligible: definition.homeEligible,
                homeEnabled: effectiveEnabled &&
                    definition.homeEligible &&
                    input.config.components[componentId].homeEnabled === true,
                organizationEnabled: input.config.components[componentId].enabled === true,
                platformEnabled: definition.platformEnabled && definition.status === "active",
                requiredEntitlementIds: definition.requiredEntitlementIds,
                sortOrder: definition.sortOrder,
                unavailableReasons,
                userConfigurable: definition.userConfigurable,
            },
        ];
    }));
    const enabledComponentIds = islamicComponentIds.filter((componentId) => components[componentId].effectiveEnabled);
    const homeEligibleComponentIds = islamicComponentIds.filter((componentId) => components[componentId].effectiveEnabled && components[componentId].homeEligible);
    const homeEnabledComponentIds = islamicComponentIds.filter((componentId) => components[componentId].homeEnabled);
    return {
        components,
        dailyAyahReference: input.config.dailyAyahReference,
        dailyContentDate: input.config.dailyContentDate,
        dailyContentMode: input.config.dailyContentMode,
        dailyDuaReference: input.config.dailyDuaReference,
        dailyHadithReference: input.config.dailyHadithReference,
        enabledComponentIds,
        hijriDateDisplay: input.config.hijriDateDisplay,
        homeEnabledComponentIds,
        homeEligibleComponentIds,
        prayerSubCapabilities: {
            qibla: {
                dependencyComponentId: "prayer",
                effectiveEnabled: components.prayer.effectiveEnabled,
            },
        },
        schemaVersion: 1,
        source: "p1_islamic_components",
        updatedAt: input.timestamp,
    };
}
export function buildOrganizationIslamicComponentDirectoryProjection(effective, timestamp) {
    return {
        islamicComponents: {
            components: effective.components,
            dailyAyahReference: effective.dailyAyahReference,
            dailyContentDate: effective.dailyContentDate,
            dailyContentMode: effective.dailyContentMode,
            dailyDuaReference: effective.dailyDuaReference,
            dailyHadithReference: effective.dailyHadithReference,
            enabledComponentIds: effective.enabledComponentIds,
            hijriDateDisplay: effective.hijriDateDisplay,
            homeEnabledComponentIds: effective.homeEnabledComponentIds,
            homeEligibleComponentIds: effective.homeEligibleComponentIds,
            prayerSubCapabilities: effective.prayerSubCapabilities,
            schemaVersion: effective.schemaVersion,
            source: effective.source,
            updatedAt: effective.updatedAt,
        },
        updatedAt: timestamp,
    };
}
export function diffOrganizationIslamicComponentConfig(before, after) {
    return islamicComponentIds
        .map((componentId) => ({
        componentId,
        newValue: after.components[componentId],
        oldValue: before.components[componentId],
    }))
        .filter((change) => change.oldValue.enabled !== change.newValue.enabled ||
        change.oldValue.homeEnabled !== change.newValue.homeEnabled);
}
function componentIdListValue(value) {
    if (!Array.isArray(value)) {
        return null;
    }
    const values = [];
    const seen = new Set();
    for (const item of value) {
        if (typeof item !== "string" || !isIslamicComponentId(item)) {
            return null;
        }
        if (!seen.has(item)) {
            values.push(item);
            seen.add(item);
        }
    }
    return values;
}
function textValue(value, maxLength) {
    if (typeof value !== "string") {
        return null;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 && trimmed.length <= maxLength ? trimmed : null;
}
function optionalReferenceValue(value) {
    if (value == null || value === "") {
        return null;
    }
    if (typeof value !== "string") {
        return null;
    }
    const trimmed = value.trim();
    return /^[A-Za-z0-9:_-]{1,140}$/.test(trimmed) ? trimmed : null;
}
function optionalDateIdValue(value) {
    if (value == null || value === "") {
        return null;
    }
    if (typeof value !== "string") {
        return null;
    }
    const trimmed = value.trim();
    return /^\d{4}-\d{2}-\d{2}$/.test(trimmed) ? trimmed : null;
}
function optionalValueWasMalformed(value, parsedValue) {
    return value != null && value !== "" && parsedValue === null;
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
